// export constants that we use in the rest of the program to avoid working with strings.
export const getChannelsProviders = "getChannelsProviders"
export const getChannelsColumnTypes = "getChannelsColumnTypes"
export const getChannelsMeasures = "getChannelsMeasures"
export const executeChannelsQuery = "executeChannelsQuery"
export const executeChannelsRoFQuery = "executeChannelsRoFQuery"
export const executeChannelsRoFExport = "executeChannelsRoFExport"
export const executeExportChannelsQuery = "executeExportChannelsQuery"
export const executeScheduleQuery = "executeScheduleChannelsQuery";

